import TaskItem from '@tiptap/extension-task-item'

export const TASKITEM_NAME = 'taskItem' as const

/**
 * Our customized variant of the official TaskItem extension.
 *
 * @remarks
 *   Nested task items are not currently enabled. We don't set the `nested`
 *   option, so TipTap's default applies and the editor cannot create a task
 *   list inside a task item. If nesting is ever enabled, review the
 *   `toggleTaskItemChecked` and the preview click handling.
 */
export const TaskItemNode = TaskItem.extend({
  name: TASKITEM_NAME,
  /**
   * Override `renderHTML()`. Used by stored HTML, the server renderer,
   * and any static render without a custom node mapping.
   */
  renderHTML({ node, HTMLAttributes }) {
    const originalHTML = this.parent?.({ node, HTMLAttributes })

    // If undefined, return fallback structure
    if (!originalHTML || !Array.isArray(originalHTML)) {
      return ['li', HTMLAttributes, 0]
    }

    const labelElmSpec = originalHTML[2] // Get label element

    if (Array.isArray(labelElmSpec)) {
      const inputElmSpec = labelElmSpec[1] // Get input element

      if (Array.isArray(inputElmSpec)) {
        const inputElmAttrs = inputElmSpec[1] // Get input element attributes

        if (inputElmAttrs && typeof inputElmAttrs === 'object' && !Array.isArray(inputElmAttrs)) {
          inputElmAttrs.disabled = true // Inject `disabled` attribute to disable interactivity
        }
      }
    }

    return originalHTML
  },
})
